const RadioCheckboxRenderer = ({ onChangeHandler, value, ...props }) => {
  return (
    <input
      {...props}
      type="checkbox"
      checked={value}
      onChange={onChangeHandler}
    />
  );
};

export default RadioCheckboxRenderer;
